enum QbdCustomFieldsTypeEnum {
    ITEMS = "Items",
    CUSTOMERS = "Customers",
}

export default QbdCustomFieldsTypeEnum;
